import { Box, Button, Typography } from '@mui/material';
import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useResponseByTemplateIdQuery } from '../../hooks/queries/qhse/forms/useFormResponsesQuery';
import { FormTemplateWithSections } from '../../services/apiSLTP/qhse/forms/formTemplates';
import { capitalizeFirstLetter } from '../../utils/capitalize';
import Icon from '../shared/Icon';
import ScrollPageContainer from '../shared/ScrollPageContainer';
import FormResponsesTable from '../tables/qhse/forms/FormResponsesTable';
import FormResponse from './FormResponse';
import { formResponseStatusEnum } from '../../constants/forms';

interface FormResponsesProps {
    formTemplate: FormTemplateWithSections;
}

const FormResponses: React.FC<FormResponsesProps> = ({ formTemplate }) => {
    const { t } = useTranslation();
    const scrollContainerRef = useRef<HTMLDivElement>(null);

    const {
        data: dataResponses,
        isLoading: isResponsesLoading,
        refetch: refetchResponses,
    } = useResponseByTemplateIdQuery({ templateId: formTemplate._id });

    const [selectedResponseId, setSelectedResponseId] = useState<string | null>(null);

    return (
        <ScrollPageContainer ref={scrollContainerRef}>
            {!selectedResponseId ? (
                <>
                    <Box sx={{ padding: 2 }}>
                        <Typography variant="h4">
                            {dataResponses?.filter((response) => response.status === formResponseStatusEnum.SUBMITTED).length}{' '}
                            {capitalizeFirstLetter(t('responses'))}
                        </Typography>
                    </Box>
                    <Box sx={{ padding: 1 }}>
                        <FormResponsesTable
                            templateName={formTemplate.title}
                            templateId={formTemplate._id}
                            onSelectResponse={setSelectedResponseId}
                            responses={dataResponses}
                            isResponsesLoading={isResponsesLoading}
                            showSiteColumn={formTemplate.isSiteEnabled}
                        />
                    </Box>
                </>
            ) : (
                <FormResponse formTemplate={formTemplate} selectedResponseId={selectedResponseId} onBack={() => setSelectedResponseId(null)} />
            )}
        </ScrollPageContainer>
    );
};

export default FormResponses;
